import {Component, Inject, OnInit, PLATFORM_ID, signal, WritableSignal} from '@angular/core';
import {isPlatformBrowser, NgOptimizedImage} from "@angular/common";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {InputTextModule} from "primeng/inputtext";
import {FormsModule} from "@angular/forms";
import {ButtonDirective} from "primeng/button";
import {CarrouselGovCoComponent} from "../carrousel-gov-co/carrousel-gov-co.component";
import {CardModule} from "primeng/card";
import {CardPQRSDF} from "../../../../shared/interfaces/sede_electronica";
import {SafeResourcePipe, Utils} from "lib-base";
import {firstValueFrom, forkJoin} from "rxjs";
import {Router, RouterLink} from "@angular/router";
import {MessageService} from "primeng/api";

@Component({
  selector: 'app-sele-electronica-pqrsdf',
  standalone: true,
  imports: [
    NgOptimizedImage,
    TranslatePipe,
    InputTextModule,
    FormsModule,
    ButtonDirective,
    CarrouselGovCoComponent,
    CardModule,
    SafeResourcePipe,
    RouterLink
  ],
  templateUrl: './sede-electronica-pqrsdf.component.html',
  styleUrl: './sede-electronica-pqrsdf.component.scss'
})
export class SedeElectronicaPqrsdfComponent implements OnInit {

  cards: CardPQRSDF[] = [];
  searchProcedure: string | undefined = undefined;
  translations:any = {};
  placeholderSearch: WritableSignal<any> = signal(null);

  constructor(private _t: TranslateService, private router:Router,
              private _ms: MessageService,) {}

  ngOnInit(): void {
    this.initCards();
    this.initTranslations().then();

  }

  private initCards() {
    this.cards = [
      {
        img: {
          src: 'assets/img/svg/gov-ico-pqrsd-Peticion.svg',
          alt: 'text'
        },
        titleHtml: '<h2 class=" my-0 font-18 font-normal animated-text">Hacer <span class="font-medium">petición</span></h2> ',
        description: 'Derecho a solicitar a la autoridad por interés general o particular y a recibir respuesta.',
        link:'/sede-electronica/formulario-pqrsd/Peticion'
      }, {
        img: {
          src: 'assets/img/svg/gov-ico-pqrsd-Queja.svg',
          alt: 'text'
        },
        titleHtml: '<h2  class=" my-0 font-18 animated-text font-normal">Poner una <span class="font-medium">Queja</span></h2> ',
        description: 'Expresión de inconformidad sobre servidores públicos en ejercicio de sus funciones.',
        link:'/sede-electronica/formulario-pqrsd/Queja'
      }, {
        img: {
          src: 'assets/img/svg/gov-ico-pqrsd-Reclamo.svg',
          alt: 'text'
        },
        titleHtml:'<h2  class=" my-0 font-18 font-normal animated-text">Hacer <span class="font-medium">Reclamo</span></h2> ',
        description: 'Derecho a exigir solución por un servicio indebido o falta de atención a una solicitud.',
        link:'/sede-electronica/formulario-pqrsd/Reclamo'
      }, {
        img: {
          src: 'assets/img/svg/gov-ico-pqrsd-Sugerencia.svg',
          alt: 'text'
        },
        titleHtml:'<h2  class=" my-0 font-18 font-normal animated-text">Hacer <span class="font-medium">Sugerencia</span></h2> ',
        description: 'Derecho a exigir solución por un servicio indebido o falta de atención a una solicitud.',
        link:'/sede-electronica/formulario-pqrsd/Sugerencia'
      }, {
        img: {
          src: 'assets/img/svg/gov-ico-pqrsd-Denuncia.svg',
          alt: 'text'
        },
        titleHtml: '<h2  class=" my-0 font-18 font-normal animated-text">Hacer <span class="font-medium">Denuncia</span></h2> ',
        description: 'Derecho a exigir solución por un servicio indebido o falta de atención a una solicitud.',
        link:'/sede-electronica/formulario-pqrsd'
      },{
        img: {
          src: 'assets/img/svg/gov-ico-pqrsd-Felicitacion.svg',
          alt: 'text'
        },
        titleHtml: '<h2  class=" my-0 font-18 font-normal animated-text">Dejar <span class="font-medium">Felicitaciones</span></h2> ',
        description: 'Derecho a exigir solución por un servicio indebido o falta de atención a una solicitud.',
        link:'/sede-electronica/formulario-pqrsd/Felicitaciones'
      },


    ];
  }

  protected searchRadicado = () => {
        if (!this.searchProcedure || !this.searchProcedure.trim()) {
        this._ms.add({ severity: 'warn', summary: this.translations.warnSummary, detail: this.translations.completeCampos });
        return;
      }
      this.router.navigateByUrl(`/sede-electronica/estado-pqrsdf/${this.searchProcedure}`).then();

  }

  redirectTo(section:string){
    this.router.navigate(['/sede-electronica',section]).then();
  }

  async initTranslations() {
    this.translations = await firstValueFrom(forkJoin({
      placeholderFirst: this._t.get('components.app-sede-electronica-pqrsdf.subtitle-movil'),
      placeholderSecond: this._t.get('components.app-sede-electronica-pqrsdf.placeholder-search-movil'),
      warnSummary: this._t.get('form.msg.warn-summary'),
      completeCampos: this._t.get('form.msg.complete-campos'),
    }));
    const value: any = (this.isMobile) ? {bold: this.translations.placeholderSecond}
      : {bold: this.translations.placeholderFirst, normal: this.translations.placeholderSecond};
    this.placeholderSearch.set(value);
  }

  get isMobile(){
    return Utils.isMobile();
  }

}
